"use client";

import { useState } from "react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import classes from "./hairColorChanger.module.css";

type CompareSliderProps = {
  beforeSrc: string;
  afterSrc: string;
  beforeAlt: string;
  afterAlt: string;
  className?: string;
};

export default function CompareSlider({ beforeSrc, afterSrc, beforeAlt, afterAlt, className }: CompareSliderProps) {
  const [pos, setPos] = useState(50);

  return (
    <div className={`${classes.compareSlider} ${className || ""}`}>
      <img src={afterSrc} alt={afterAlt} className={classes.compareImg} draggable={false} style={{ userSelect: "none" }} />
      <img
        src={beforeSrc}
        alt={beforeAlt}
        className={classes.compareImg}
        draggable={false}
        style={{ userSelect: "none", position: "absolute", inset: 0, clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />

      <div className={classes.compareDivider} style={{ left: `${pos}%` }}>
        <div className={classes.compareHandle}>
          <IconChevronLeft size={14} color="#333" />
          <IconChevronRight size={14} color="#333" />
        </div>
      </div>

      <span className={`${classes.comparePill} ${classes.comparePillLeft}`}>Before</span>
      <span className={`${classes.comparePill} ${classes.comparePillRight}`}>After</span>

      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after"
        className={classes.compareRange}
      />
    </div>
  );
}
